export default __webpack_public_path__ + "media/flavours/glitch/images/glitch-preview.jpg";